<template>
    <ul class="dashboard-config-tabs">
        <DashboardConfigurationTab v-for="el in sections"
            :key="el.section"
            :section="el"
            :selectedSection="selectedSection"
            :config="config"
            @click.native="selectSection(el)" />
    </ul>
</template>
<script>
import DashboardConfigurationTab from './DashboardConfigurationTab.vue';

export default {
    components: {DashboardConfigurationTab},
    props: {
        /**
         * List of configuration sections to render as tabs.
         */
        sections: {type: Array, default: () => ([])},
        /**
         * Section key of the currently selected tab, forwarded to each
         * DashboardConfigurationTab to determine its active state.
         */
        selectedSection: {type: String, default: ''},
        /**
         * Current widget configuration, forwarded to each tab so it can validate
         * its own section against it.
         */
        config: {type: Object, default: () => ({})}
    },
    methods: {
        selectSection: function (section) {
            this.$emit('onSelect', section);
        }
    },
}
</script>
<style lang="scss" scoped>
.dashboard-config-tabs {
    display: flex;
    flex-direction: column;
    position: relative;
}
</style>